import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-operation",
  "use": "icon-operation-usage",
  "viewBox": "0 0 18 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 16\" class=\"icon\" id=\"icon-operation\">\r\n  <path id=\"icon-operation_运营\" class=\"cls-1\" d=\"M395.393,614.732H380.6a1.614,1.614,0,0,1-1.6-1.624V602.62A1.614,1.614,0,0,1,380.6,601h14.8a1.613,1.613,0,0,1,1.6,1.624v10.488A1.613,1.613,0,0,1,395.393,614.732Zm-14.8-12.653a0.538,0.538,0,0,0-.533.541v10.488a0.538,0.538,0,0,0,.533.541h14.8a0.538,0.538,0,0,0,.533-0.541V602.62a0.538,0.538,0,0,0-.533-0.541H380.6Zm9.127,8.593a0.531,0.531,0,0,1-.372-0.153l-3.755-3.713-2.731,3.46a0.525,0.525,0,0,1-.748.085,0.547,0.547,0,0,1-.083-0.761l3.1-3.926a0.524,0.524,0,0,1,.383-0.2,0.54,0.54,0,0,1,.4.152l3.769,3.726,3.447-4.1a0.528,0.528,0,0,1,.751-0.059,0.548,0.548,0,0,1,.059.763l-3.816,4.534a0.534,0.534,0,0,1-.381.188h-0.024ZM390.909,617h-5.828a0.541,0.541,0,0,1,0-1.082h5.828A0.541,0.541,0,0,1,390.909,617Z\" transform=\"translate(-379 -601)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/operation.svg
// module id = Dh6m
// module chunks = 127